import { render, staticRenderFns } from "./DropsMainInfo.vue?vue&type=template&id=c1b62e88&"
import script from "./DropsMainInfo.vue?vue&type=script&lang=js&"
export * from "./DropsMainInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports